import { createUrl, restPost } from '~/src/dash/api/rest';
import { Order } from '~/src/dash/components/tables/ListViewTable/common';
import { IInventoryRule } from '~/src/dash/apiV2/inventory-rules/inventoryRules';

export interface ICustomDataQueryParams {
  Search?: string;
  Page: number;
  PageSize: number;
  OrderBy: string;
  OrderDirection: Order;
}

export interface IGetCustomDataResponse {
  InvRuleCustomsData: ICustomData[];
  TotalCount: number;
}

export async function getCustomData(
  publisherID: string,
  query: ICustomDataQueryParams,
  signal?: AbortSignal,
): Promise<IGetCustomDataResponse> {
  const reqUrl = `${createUrl('/inv_rule_customs_data/search', publisherID, 'v1')}`;
  const response = await restPost<unknown>(reqUrl, query, undefined, undefined, signal);
  return (
    (response?.parsedBody as IGetCustomDataResponse) || {
      InvRuleCustomsData: [],
      TotalCount: 0,
    }
  );
}

export interface ICustomData {
  ID: number;
  Name: string;
  Custom5: string;
  Custom6: string;
  Custom7: string;
  Custom8: string;
  Custom9: string;
  Custom10: string;
  Custom11: string;
  Custom12: string;
  Custom13: string;
  Custom14: string;
  Custom15: string;
  Custom16: string;
  Custom17: string;
  Custom18: string;
  AssociatedInventoryRules: number;
  InventoryRules: IInventoryRule[] | null;
}
